import { render } from "./HomeView.vue?vue&type=template&id=76621014&bindings={}"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
script.render = render

export default script